import React, { useState } from "react";
import { Link } from "react-router-dom";
import { RowsPhotoAlbum } from "react-photo-album";
import "react-photo-album/rows.css";

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const photos = [
    "/gallery/IMG_7366.webp",
    "/gallery/IMG_7254.webp",
    "/gallery/IMG_7367.webp",
    "/gallery/IMG_7811.webp",
    "/gallery/IMG_7814.webp",
    "/gallery/IMG_8068.webp",
    "/gallery/IMG_8073.webp",
    "/gallery/IMG_8485.webp",
    "/gallery/IMG_8523.webp",
    "/gallery/IMG_8783.webp",
    "/gallery/IMG_9043.webp",
    "/gallery/IMG_9739.webp",
    "/gallery/IMG_9741.webp",
    "/gallery/IMG_9742.webp",
    "/gallery/IMG_9743.webp",
    "/gallery/IMG_9746.webp",
    "/gallery/IMG_9747.webp",
    "/gallery/IMG_9750.webp",
    "/gallery/IMG_9754.webp",
    "/gallery/IMG_9809.webp",
    "/gallery/IMG_9823.webp",
    "/gallery/IMG_9826.webp",
    "/gallery/IMG_9828.webp",
    "/gallery/IMG_9830.webp",
    "/gallery/IMG_9833.webp",
  ].map((src) => ({ src, width: 4, height: 3 }));

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 bg-gradient-to-br from-white via-gray-50 to-cyan-50 overflow-hidden">
        {/* Background elements */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-48 -right-48 w-96 h-96 bg-gradient-to-br from-cyan-400/20 to-transparent rounded-full blur-3xl"></div>
          <div className="absolute -bottom-48 -left-48 w-96 h-96 bg-gradient-to-tr from-navy-900/20 to-transparent rounded-full blur-3xl"></div>
        </div>

        <div className="relative container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center space-x-2 bg-cyan-400/10 backdrop-blur-sm border border-cyan-400/30 rounded-full px-6 py-2 mb-8">
              <span className="w-2 h-2 bg-cyan-400 rounded-full"></span>
              <span className="text-sm font-bold text-navy-900 tracking-wide">
                OUR WORK
              </span>
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-navy-900 leading-none mb-6">
              PROJECT{" "}
              <span className="bg-gradient-to-r from-cyan-400 to-navy-800 bg-clip-text text-transparent">
                GALLERY
              </span>
            </h1>

            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              See the transformation our professional cleaning services deliver.
              Every project showcases our commitment to excellence.
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <RowsPhotoAlbum
            photos={photos}
            targetRowHeight={250}
            onClick={({ photo }) => setSelectedImage(photo.src)}
          />
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 bg-navy-900/95 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-4xl w-full">
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute -top-12 right-0 text-white hover:text-cyan-400 transition-colors"
            >
              <svg
                className="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            <div className="bg-white rounded-2xl overflow-hidden shadow-2xl">
              <div className="relative aspect-video bg-gray-100">
                <div className="absolute inset-0 bg-gradient-to-br from-cyan-400/20 via-navy-900/10 to-cyan-500/20"></div>
                <img
                  src={selectedImage}
                  alt="Cleaning project"
                  className="absolute inset-0 w-full h-full object-cover"
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-cyan-400 to-cyan-600 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `repeating-linear-gradient(45deg, transparent, transparent 35px, white 35px, white 37px)`,
            }}
          ></div>
        </div>

        <div className="relative container mx-auto px-4 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6">
            WANT RESULTS LIKE THESE?
          </h2>
          <p className="text-xl text-navy-900 font-semibold mb-8 max-w-2xl mx-auto">
            Get a free, no-obligation quote for your cleaning project today
          </p>
          <Link
            to="/get-quote"
            className="inline-block px-12 py-6 bg-navy-900 text-white font-black text-xl rounded-xl shadow-2xl hover:bg-navy-800 transition-colors"
          >
            GET YOUR FREE QUOTE
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
